import { Component, OnInit, Input, OnChanges } from '@angular/core'
import { Router, ActivatedRoute, Params } from '@angular/router';

import { animateFactory } from 'ng2-animate';
import { Question } from '../../../model';

// import { environment } from '../../../../';
import { CookieManagerService, ErrorManagerService, HttpClientService, AnswerSelectorPipe } from '../../../../shared';
import { AnswersStatus, ImageOptions, resourceUrl, ApiEndpoints } from '../../../constant';

@Component({
  selector: 'app-gp2-tp7',
  templateUrl: './gp2-tp7.component.html',
  styleUrls: ['./gp2-tp7.component.css', '../../../../css/paper-layouts.component.css']
})
export class Gp2Tp7Component implements OnInit {

  @Input() question: Question;
  @Input() type: string;

  @Input() isSubmit: boolean;
  yes: string = AnswersStatus.yes;
  no: string = AnswersStatus.no;
  public answerQustion = new AnswerSelectorPipe();
  public forcusClasses: Array<string> = AnswersStatus.answerClasses;
  public selectedClasses: Array<string> = AnswersStatus.answerClasses;
  public answerSelectorPipe = new AnswerSelectorPipe();
  public resourceImage: string = resourceUrl;
  public defaultImage: string = ImageOptions.defaultImage;
  public enable: boolean = false;
  public answerTypeText = "TEXT";
  public answerTypeImage = "IMAGE";
  public answerTypeTextImage = "YES_NO";
  public descriptionTypeText = "TEXT";
  public descriptionTypeImage = "IMAGE";
  public descriptionTypeTextImage = "TEXT_IMAGE";


  constructor(
    private httpClientService: HttpClientService,
    private route: ActivatedRoute,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService
  ) { }

  ngOnInit() {
    this.getColorCode();
  }

  getColorCode() {
    let answerSelectorPipe = new AnswerSelectorPipe();
    if (this.type == ApiEndpoints.questingViewingTypeReport) {
      let getCorrecctClorCodeForReport = answerSelectorPipe.getCorrecctClorCodeForReport(this.question);
      this.selectedClasses = getCorrecctClorCodeForReport['selectedClasses'];
      this.forcusClasses = getCorrecctClorCodeForReport['forcusClasses'];
    } else {
      let getCorrecctClorCodeForExam = answerSelectorPipe.getCorrecctClorCodeForExam(this.question);
      this.selectedClasses = getCorrecctClorCodeForExam['selectedClasses'];
      this.forcusClasses = getCorrecctClorCodeForExam['forcusClasses'];
    }
  }

  ngOnChanges(changes) {
    if (this.question.userOptionUnderline) {
      this.forcusClasses = AnswersStatus.answerClasses;
      this.selectedClasses = this.answerQustion.convert(false, { 'index': parseInt(this.question.selectedAnswerIndex) });
    }
    if (this.question.userOptionCircle) {
      this.selectedClasses = AnswersStatus.answerClasses;
      this.forcusClasses = this.answerQustion.transform(false, { 'index': parseInt(this.question.selectedAnswerIndex) });
    }
    if (!this.question.selectedAnswerid) {
      this.forcusClasses = AnswersStatus.answerClasses;
      this.selectedClasses = AnswersStatus.answerClasses;
    }
  }

  selectCorrectAnswer(answer, answerIndex) {
    this.selectedClasses = AnswersStatus.answerClasses;
    this.forcusClasses = this.answerQustion.transform(false, { 'array': this.forcusClasses, 'index': answerIndex });
    this.question.selectedAnswerIndex = answerIndex;
    this.question.selectedAnswerid = answer;
    this.question.userOptionCircle = true;
    this.question.userOptionUnderline = false;
    if (!this.question.selectedAnswerid) {
      this.selectedClasses = AnswersStatus.answerClasses;
      this.forcusClasses = AnswersStatus.answerClasses;
    }
  }

  enableButton(answerType): boolean {
    if (this.question.answerType == 'UNDERLINE_CIRCLE') {
      this.enable = false;
      return this.enable;
    } else {
      this.enable = true;
      return this.enable;
    }
  }

  underlineCorrectAnswer(answer, answerIndex) {
    // if (this.question.selectedAnswerIndex !== answerIndex) {
    this.forcusClasses = AnswersStatus.answerClasses;
    this.selectedClasses = this.answerQustion.convert(false, { 'array': this.selectedClasses, 'index': answerIndex });
    this.question.selectedAnswerIndex = answerIndex;
    this.question.selectedAnswerid = answer;
    this.question.userOptionUnderline = true;
    this.question.userOptionCircle = false;
    if (!this.question.selectedAnswerid) {
      this.forcusClasses = AnswersStatus.answerClasses;
      this.selectedClasses = AnswersStatus.answerClasses;
    }
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-layouts/group/gp2-tp7/gp2-tp7.component.ts